module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "do-subs"
  }, [_c('transition', {
    attrs: {
      "name": "fadeOut"
    }
  }, [(_vm.isInitialLoading) ? _c('DoSplash', {
    key: "initial-splash"
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "do-subs__header"
  }, [_c('div', {
    staticClass: "do-subs__header__div"
  }, [_c('h1', [_vm._v("Vikardækning")]), _vm._v(" "), _c('DoChangeDayNav', {
    attrs: {
      "date": _vm.date
    },
    on: {
      "today": function($event) {
        return _vm.setDate('today')
      },
      "prev": function($event) {
        return _vm.setDate('prev')
      },
      "next": function($event) {
        return _vm.setDate('next')
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dateFormatted))]), _vm._v(" "), (_vm.isLoadingEvents) ? _c('div', {
    staticClass: "do-spinner"
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "do-subs__header__div"
  }, [_c('label', [_vm._v("Antal fraværende: " + _vm._s(_vm.absentUsers.length))])])]), _vm._v(" "), _c('div', {
    staticClass: "do-subs__body"
  }, [_c('Scheduler', {
    attrs: {
      "events": _vm.events,
      "klassCalendars": _vm.klassCalendars,
      "userCalendars": _vm.userCalendars,
      "allCalendarsInHash": _vm.allCalendarsInHash
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-638e61a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Substitution/Substitution.vue
// module id = 1632
// module chunks = 1